// =============================================================
// VARIANCE — The Executive Command Center
// File      : SalesPipelines.tsx
// Location  : /home/Applications/variance/web/src/pages/SalesPipelines.tsx
// Owner     : VARIANCE frontend application only
// Purpose   : The page holding separate tabs for Leads and Deals.
// =============================================================

import { useState } from 'react';
import { ArrowLeft, Users, Handshake } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { LeadPipeline } from './LeadPipeline';
import { DealPipeline } from './DealPipeline';

export function SalesPipelines() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<'leads' | 'deals'>('leads');

  return (
    <div className="h-full flex flex-col space-y-4">
      
      {/* Header & Tabs */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 border-b pb-2" style={{ borderColor: 'var(--border-subtle)' }}>
        <div className="flex items-center gap-4">
          <button onClick={() => navigate('/sales')} className="p-2 rounded-full hover:bg-[var(--bg-panel-alt)] transition-colors" style={{ color: 'var(--text-secondary)' }}>
            <ArrowLeft size={24} />
          </button>
          
          {/* Tabs */}
          <div className="flex items-center gap-6 mt-2">
            <button 
              onClick={() => setActiveTab('leads')}
              className={`pb-2 text-lg font-bold transition-all border-b-2 ${activeTab === 'leads' ? 'border-[var(--brand-accent)]' : 'border-transparent opacity-50 hover:opacity-100'}`}
              style={{ color: activeTab === 'leads' ? 'var(--brand-accent)' : 'var(--text-primary)' }}
            >
              <div className="flex items-center gap-2"><Users size={18} /> Leads</div>
            </button>
            <button 
              onClick={() => setActiveTab('deals')}
              className={`pb-2 text-lg font-bold transition-all border-b-2 ${activeTab === 'deals' ? 'border-[var(--brand-accent)]' : 'border-transparent opacity-50 hover:opacity-100'}`}
              style={{ color: activeTab === 'deals' ? 'var(--brand-accent)' : 'var(--text-primary)' }}
            >
              <div className="flex items-center gap-2"><Handshake size={18} /> Deals</div>
            </button>
          </div>
        </div>
      </div>

      {/* Content Area */}
      <div className="flex-1 overflow-hidden pt-2">
        {activeTab === 'leads' ? <LeadPipeline /> : <DealPipeline />}
      </div>

    </div>
  );
}
